<template>
    <div>
        <Breadcrumbs main="Admin" submain="Disasters" title="Occupancy Summary" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <b-row class="d-flex justify-content-center align-items-center">
                                <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                        <feather type="filter"></feather>
                                        <h7>Filter</h7> 
                                    </div>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="filterShow || shelter || current_date">
                                        <feather type="x"></feather>
                                        <h7>Clear All</h7>
                                    </div>
                                </b-col> 
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <div class="row mt-2" v-if="filterShow">
                                <div class="col-md-6">
                                    <div class="grid-container mt-sm-0">
                                        <div class="grid-item">
                                            <span>Shelter</span>
                                            <b-form-select v-model="shelter" :options="formattedShelters"></b-form-select>
                                        </div> 
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="grid-container mt-sm-0">
                                        <div class="grid-item">
                                            <span>Date {{ current_date }}</span>
                                            <datepicker placeholder="Select Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="current_date"></datepicker>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue mt-4">
                                    <b-table show-empty stacked="md" :items="summary_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>

                                        <template #cell(shelter)="row">
                                            <div v-if="row.item.shelter">
                                                <p>{{ row.item.shelter.name }}</p>
                                                <b-badge style="cursor: pointer;" @click="gotoURL(row.item.shelter.id, row.item.created_at)">View Dashboard</b-badge>
                                            </div>
                                        </template>

                                        <template #cell(created)="row">
                                            <div v-if="row.item.created_at">
                                                <p>{{ getDate(row.item.created_at) }}</p>
                                            </div>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import loader from '../loader/loader.vue';
    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';

    export default {
        components: {
            loader,
            Datepicker
        },
    
        data() {
            return {
                host: myHost.host,
                filterShow: false,
                shelter: null,
                current_date: null,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'shelter',
                        label: 'Shelter',
                        sortable: true
                    },
                    {
                        key: 'total_members',
                        label: 'Total Member',
                        sortable: true
                    },
                    {
                        key: 'created',
                        label: 'Date',
                        sortable: true
                    }
                ],
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 15, 20]
            };
        },
    
        computed: {
            ...mapState({
                summary_list: state => state.contact.summary_list,
                shelters: state => state.shelter.shelter,
                loading: state => state.contact.contactLoading,
                error: state => state.contact.contactError
            }),

            formattedShelters() {
                return [{
                        value: '',
                        text: 'Select a shelter',
                        disabled: true
                    },
                    ...this.shelters.map(shelter => ({
                        value: shelter.id,
                        text: shelter.name
                    }))
                ] 
            }
        },

        watch: {
            shelter(newVal, oldVal) {
                if(this.shelter != null && this.current_date == null) {
                    this.$router.replace({
                        path: '/disasters/occupancy-summary',
                        query: {
                            shelter: this.shelter
                        }
                    });
                } else if (this.shelter != null && this.current_date != null) {
                    this.$router.replace({
                        path: '/disasters/occupancy-summary',
                        query: {
                            shelter: this.shelter,
                            current_date: this.current_date
                        }
                    });
                } else if (this.current_date != null && this.shelter == null) {
                    this.$router.replace({
                        path: '/disasters/occupancy-summary',
                        query: {
                            current_date: this.current_date
                        }
                    });
                } else {
                    this.$router.replace({
                        path: '/disasters/occupancy-summary'
                    });
                }

                this.$store.dispatch("contact/fetchOccupancySummary", {
                    shelter: this.$route.query.shelter,
                    current_date: this.$route.query.current_date
                })
            },

            current_date(newVal, oldVal) {
                if(this.current_date) {
                    this.current_date = moment(String(this.current_date)).format("YYYY-MM-DD")
                } else {
                    this.current_date = null
                }

                if(this.shelter != null && this.current_date == null) {
                    this.$router.replace({
                        path: '/disasters/occupancy-summary',
                        query: {
                            shelter: this.shelter
                        }
                    });
                } else if (this.shelter != null && this.current_date != null) {
                    this.$router.replace({
                        path: '/disasters/occupancy-summary',
                        query: {
                            shelter: this.shelter,
                            current_date: this.current_date
                        }
                    });
                } else if (this.current_date != null && this.shelter == null) {
                    this.$router.replace({
                        path: '/disasters/occupancy-summary',
                        query: {
                            current_date: this.current_date
                        }
                    });
                } else {
                    this.$router.replace({
                        path: '/disasters/occupancy-summary'
                    });
                }

                this.$store.dispatch("contact/fetchOccupancySummary", {
                    shelter: this.$route.query.shelter,
                    current_date: this.$route.query.current_date
                })
            }
        },
    
        mounted() {
            this.$store.dispatch("shelter/fetchShelter")
            this.$store.dispatch("contact/fetchOccupancySummary", {
                shelter: this.$route.query.shelter,
                current_date: this.$route.query.current_date
            })
        },

        methods: { 
            clearFilter() {
                this.filterShow = false,
                this.shelter = null
                this.current_date = null

                this.$router.replace({
                    path: '/disasters/occupancy-summary'
                });
            },

            toggleFilterShow() {
                this.filterShow = !this.filterShow
            },

            getDate(date) {
                return moment(String(date)).format("YYYY-MM-DD");
            },

            gotoURL(id, date){
                this.$router.push(
                    {
                        path: '/dashboard/shelter',
                        query: {
                            shelter: id,
                            date: moment(String(date)).format("YYYY-MM-DD")
                        }
                    }
                )
            }
        }
    };
    </script>
    